export default "__VITE_ASSET__Bmglt$lw__"